import { useTranslation } from 'react-i18next';
import type { ErrorInfo } from 'react';
import { Button } from 'v5/design-system/Button';
import { FullPageDashboardLink } from 'v5/patterns/page-layout/FullPageDashboardLink';
import { FullPageErrorLog } from 'v5/patterns/page-layout/FullPageErrorLog';
import { FullPageStatusLayout } from 'v5/patterns/page-layout/FullPageStatusLayout';
import {
  formatAppCrashErrorLog,
  resolveAppCrashDashboardHref
} from './formatAppCrashErrorLog';

export type AppCrashErrorScreenProps = {
  error: Error;
  errorInfo?: ErrorInfo | null;
  className?: string;
};

export function AppCrashErrorScreen({
  error,
  errorInfo = null,
  className
}: AppCrashErrorScreenProps) {
  const { t } = useTranslation('core', { keyPrefix: 'app_crash' });
  const { display, clipboard } = formatAppCrashErrorLog(error, errorInfo);
  const dashboardHref = resolveAppCrashDashboardHref();

  return (
    <FullPageStatusLayout
      idPrefix="app-crash"
      className={className}
      title={t('title')}
      description={t('description')}
      actions={
        <>
          <Button
            type="button"
            variant="primary"
            size="md"
            onClick={() => window.location.reload()}
          >
            {t('refresh')}
          </Button>
          {dashboardHref ? (
            <FullPageDashboardLink href={dashboardHref}>
              {t('goToDashboard')}
            </FullPageDashboardLink>
          ) : null}
        </>
      }
    >
      <FullPageErrorLog
        label={t('errorLogLabel')}
        display={display}
        clipboard={clipboard}
      />
    </FullPageStatusLayout>
  );
}
